import type { PrimaryEntityId } from "../doc/primaryEntityId";
import type { DocEntityBase } from "../entities/docEntityBase";
import type { CMUProfile } from "../masonry/masonryTypes";

export enum MasonryType {
  CONCRETE = "CONCRETE",
  /* PLACEHOLDER FOR BRICK AND STONE - still in product design phase */
  //   BRICK = "BRICK",
  //   STONE = "STONE",
  OTHER = "OTHER",
}

export interface MasonryBase<T extends MasonryType> extends DocEntityBase<"MASONRY_COMPONENT"> {
  readonly id: PrimaryEntityId<"MASONRY_COMPONENT">;
  readonly name: string;
  readonly masonryType: T;
}

export interface Concrete extends MasonryBase<MasonryType.CONCRETE> {
  readonly profile: CMUProfile;
}

export interface OtherMasonryComponent extends MasonryBase<MasonryType.OTHER> {
  readonly width: number;
  readonly height: number;
  readonly length: number;
}

export type MasonryComponentEntity = Concrete | OtherMasonryComponent; // | Brick | Stone;

export type MasonryComponentId = MasonryComponentEntity["id"];

export type MasonryComponentEntityTable = {
  [id: MasonryComponentId]: MasonryComponentEntity;
};
